import { Directive, inject, input } from '@angular/core';
import { MarkCalculationMethod } from '@examdojo/models/markscheme-v2';
import { ReferenceQuestionUIModel } from '../reference-question.model';
import { ReferenceQuestionPopupService } from './reference-question-popup.service';

@Directive({
  selector: '[dojoReferenceQuestionPopupTrigger]',
  standalone: true,
  providers: [ReferenceQuestionPopupService],
  host: {
    '(click)': 'openPopup()',
    class: 'cursor-pointer',
  },
})
export class ReferenceQuestionPopupTriggerDirective {
  private readonly popupService = inject(ReferenceQuestionPopupService);

  readonly markCalculationMethod = input.required<MarkCalculationMethod>();
  readonly referenceQuestion = input.required<ReferenceQuestionUIModel>();

  openPopup() {
    this.popupService.openDialog({
      input: { referenceQuestion: this.referenceQuestion(), markCalculationMethod: this.markCalculationMethod() },
    });
  }
}
